// extracted by mini-css-extract-plugin
export var active = "_9i-a";
export var activeIndicator = "_9i-9";
export var disabled = "_9i-b";
export var fullWidth = "_9i-2";
export var lg = "_9i-7";
export var md = "_9i-6";
export var redoButtonTabGroup = "_9i-0";
export var sm = "_9i-5";
export var tabButton = "_9i-4";
export var tabButtonsContainer = "_9i-1";
export var themeDestructive = "_9i-d";
export var themeNormal = "_9i-c";
export var themeSuccess = "_9i-e";
export var xl = "_9i-8";
export var xs = "_9i-3";